<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!purchasesOrder">
      <span class="loader"></span>
    </span>
    <purchases-order-form
      v-if="purchasesOrder"
      :loading="loading"
      :purchasesOrderData="purchasesOrder"
      :formErrors="formErrors"
      @purchasesOrderSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import PurchasesOrderForm from "../partials/PurchasesOrderForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";

export default {
  layout: "DashboardLayout",

  components: { PurchasesOrderForm },

  mixins: [alertLeave],

  props: {
    purchasesOrderId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      purchasesOrder: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "purchasesOrders/get",
          this.purchasesOrderId
        );
        this.purchasesOrder =
          this.$store.getters["purchasesOrders/purchasesOrder"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(purchasesOrder) {
      this.loading = true;
      const purchasesOrderData = cloneDeep(purchasesOrder);
      try {
        await this.$store.dispatch(
          "purchasesOrders/update",
          purchasesOrderData
        );
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_ORDERS.PURCHASES_ORDER_UPDATED"),
        });
        const purchasesOrder = await this.$store.getters[
          "purchasesOrders/purchasesOrder"
        ];
        this.$emit("onViewPurchasesOrder", purchasesOrder, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
